<!--
    描述：专家预约记录页面
    Created by asq
-->
<template>
	<div class="h100 Apage">
	  <filter-layout
		@search="searchResult"
		@reset="resetSerach"
		v-if="!routeQuery"
	  >
		<template #filter>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchForm"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="专家姓名：">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchForm.sname"
				size="small"
			  >
			  </el-input>
			</el-form-item>
			<el-form-item label="身份证号：">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchForm.idCard"
				size="small"
			  >
			  </el-input>
			</el-form-item>
			<el-form-item label="手机号码：">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchForm.phone"
				size="small"
			  >
			  </el-input>
			</el-form-item>
			<el-form-item label="所属：">
			  <el-select
				v-model="searchForm.belongingName"
				placeholder="请选择"
				size="small"
			  >
				<el-option
				  v-for="item in zjyyss"
				  :key="item.value"
				  :label="item.sname"
				  :value="item.value"
				>
				</el-option>
			  </el-select>
			</el-form-item>
		  </el-form>
		</template>

		<template #content>
		  <div class="content-header">
			<div class="title">
			  专家预约统计共： <span class="blue">{{ total }}</span> 条
			</div>
			<div class="mt10 mb10 fr">
			  <el-button
				size="small"
				class="btn-blue"
				icon="el-icon-refresh"
				type="primary"
				@click="refresh"
			  ></el-button>
			</div>
		  </div>
		  <div class="w-table-layout w-table-page">
			<div class="w-table-content" v-show="tableShow">
			  <el-table
				ref="xTable"
				:data="filterData"
				height="100%"
				highlight-current-row
				border
			  >
				<el-table-column
				  type="index"
				  label="序号"
				  align="center"
				  width="80"
				></el-table-column>
				<el-table-column
				  prop="sname"
				  label="专家姓名"
				  align="center"
				  width="120"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="idCard"
				  label="身份证号"
				  align="center"
				  width="200"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="phone"
				  label="手机号码"
				  align="center"
				  width="160"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="openBank"
				  label="开户行"
				  align="center"
				  min-width="180"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="creditCard"
				  label="银行卡号"
				  align="center"
				  min-width="180"
				  show-overflow-tooltip
				></el-table-column>
				<!-- <el-table-column prop="price"
						 label="价格(元/次)"
						 align="center"
						 width="120"
						 show-overflow-tooltip></el-table-column> -->
				<el-table-column
				  prop="belongingName"
				  label="所属"
				  align="center"
				  width="160"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="attendances"
				  label="到场次数"
				  align="center"
				  width="120"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="bookings"
				  label="预约中"
				  align="center"
				  width="120"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column align="center" width="120">
				  <template slot="header">操作</template>
				  <template slot-scope="scope">
					<!-- <el-row>
					  <span class="b-text"
						  >
						<i class="el-icon-edit"></i>明细
					  </span>
					</el-row> -->
					<el-button
					  type="primary"
					  size="small"
					  round
					  plain
					  class="table-btn"
					  v-if="roleBtns.includes('expertDetailsInfo')"
					  @click="getDetail(scope.row)"
					>
					  <svg-icon icon-class="form-details"></svg-icon> 详情
					</el-button>
				  </template>
				</el-table-column>
			  </el-table>
			</div>
			<div class="w-table-footer">
			  <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="pageList"
				:page-size="pageSize"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
			  >
			  </el-pagination>
			</div>
		  </div>
		</template>
	  </filter-layout>
	  <div class="cmain" v-if="routeQuery">
		<records-detail
		  ref="recordsDetail"
		  :expertsData="expertsData"
		  :eId="eId"
		></records-detail>
	  </div>
	</div>
  </template>

<script>
import {
	getExpertsRecordsList,
	getRecordsDetail,
} from "api/modules/expertsRecords";
import { mapState } from "vuex";

import recordsDetail from "./components/records-detail";

export default {
	name: 'Experts-records',
	components: {
		recordsDetail,
	},
	data() {
		return {
			eId: '',
			zjyyss: [
				{
					sname: '企业库',
					value: '企业库',
				},
				{
					sname: '平台库',
					value: '平台库',
				},
			],
			expertsData: {},
			detailData: [],
			zjk: [
				{
					sname: '政府采购专家库',
					value: '1001',
				},
			],
			filterData: [],
			searchForm: {
				sname: '',
				idCard: '',
				phone: '',
				belongingName: '',
			},
			loading: false,
			//筛选框
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			searchToggle: true,
			tableShow: true,
		}
	},

	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchForm')) {
				this.searchForm = JSON.parse(this.$getSessionItem('searchForm'))

				// 移除 避免污染
				this.$removeSessionItem('searchForm')
			}

			if (this.$getSessionItem('currentPage')) {
				this.currentPage = JSON.parse(
					this.$getSessionItem('currentPage')
				)

				// 移除 避免污染
				this.$removeSessionItem('currentPage')
			}

			if (this.$getSessionItem('pageSize')) {
				this.pageSize = JSON.parse(this.$getSessionItem('pageSize'))

				// 移除 避免污染
				this.$removeSessionItem('pageSize')
			}
		}
		this.getData()
	},
	methods: {
		//重置筛选框
		resetSerach() {
			this.currentPage = 1
			this.pageSize = 10
			this.searchForm = {}
			this.getData()
		},

		refresh() {
			this.currentPage = 1
			this.pageSize = 10
			this.searchForm = {}
			this.getData()
		},

		//查看明细
		getDetail(params) {
			this.expertsData = params
			this.eId = params.id
			let arr = {
				id: params.id,
				current: 1,
				size: 10,
				applyState: '1',
			}

			// 存值
			this.$setSessionItem('searchForm', JSON.stringify(this.searchForm))
			this.$setSessionItem(
				'currentPage',
				JSON.stringify(this.currentPage)
			)
			this.$setSessionItem('pageSize', JSON.stringify(this.pageSize))

			this.$router.push({
				name: 'Experts-records',
				query: {
					type: 'detail',
					id: params.id,
				},
			})
		},

		//返回列表
		goBack() {
			this.$router.push({ path: '/experts-records' })
		},

		//获得列表数据
		getData() {
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			getExpertsRecordsList(params)
				.then((res) => {
					this.loading = false
					this.filterData = res.data.records
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
					// 设置回显
					this.setChecked()
				})
				.catch((err) => {
					this.loading = false
				})
		},

		//筛选框重置
		handleClose() {
			this.dialogObj.visible = false
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 搜索
		searchResult() {
			this.currentPage = 1
			this.pageSize = 10
			this.getData()
		},
	},

	computed: {
		...mapState('dict', { hyslx: (state) => state.hyslx }),
		...mapState('dict', { cdrnrs: (state) => state.cdrnrs }),
		// ...mapState('dict', { zjyyss: (state) => state.zjyyss }),
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),

		routeQuery() {
			return this.$route.query.type
		},
	},

	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		},
	},
}
</script>

<style lang="less" scoped>
.Apage {
	padding: 0 8px;
	.breadcrumb-list {
		padding: 0 15px;
		border: 1px solid #ddd;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	/deep/ .el-breadcrumb__item {
		height: 35px;
		line-height: 35px;
	}
	.el-icon-location {
		color: #009900;
		font-size: 18px;
	}

	.search {
		font-size: 13px;
		margin-top: 10px;
		@activeColor: #409eff;
		border-bottom: 1px solid #2672cc;
		padding: 5px 0;
		min-width: max-content;
	}
	.main {
		.text {
			float: left;
			display: flex;
			height: 100%;
			margin-bottom: 10px;
			margin-left: 10px;
			.red {
				color: red;
			}
		}
		.btnGroups2 {
			float: left;
			height: 100%;
			box-sizing: border-box;
			margin-bottom: 10px;
		}
		.Atable {
			margin-top: 10px;
			height: 100%;
		}
	}
	.cmain {
		height: 100%;
		overflow-y: auto;
	}
	.mt4 {
		margin-top: 4px;
	}
	.switch {
		/deep/ .el-switch__label--right span {
			margin-left: -10px;
		}
	}
	.b-text {
		color: #2671cc;
		cursor: pointer;
	}
	.content-header{
		display: flex;
		justify-content: space-between;
		align-items: center;

		.title {
		  padding-left: 10px;
		  border-left: 4px solid #2671cc;
		  font-size: 14px;
		  color: #202020;
		}
		.blue{
		  font-size: 18px;
		  color: #2671cc;
		}
	  }
}
</style>
